module.exports = __webpack_public_path__ + "img/yijian_gaoji-1.4d57bf06.png";